/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Overlay = () => {
  // Routes that should not be scaled for mobile
  const location = useLocation();
  const excludeRoutes = [
    "/captiveportal",
    "/captiveportalpreview",
  ];

  const shouldScale = !excludeRoutes.includes(location.pathname);

  return (
    <div className={`pageWrapper d-flex ${shouldScale ? "mobile-container-scale": ""}`}>
      <Sidebar />
      <div className="contentArea d-flex flex-column">
        <Header className="flex-static" />
        <Outlet />
      </div>
    </div>
  )
};

export default Overlay;
